// extracted by mini-css-extract-plugin
export default {"title":"PDFOrShareTooltip_title__vlzUs","text":"PDFOrShareTooltip_text__vgGQj","button":"PDFOrShareTooltip_button__8-Xji","buttonWrapper":"PDFOrShareTooltip_buttonWrapper__G5zXF"};